import {  CollapseProps, Form, Modal, Radio } from 'antd';
import api from 'api';
import { NewInvitesResponse } from 'api/users';
import UploadingComponent from 'components/UploadingComponent/UploadingComponent';
import { IUserData } from 'interfaces';
import dayjs from 'dayjs';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from 'store/hook';
import fetchGroupsAndUsers, { defaultGroups } from 'store/reducers/usersGroupCreator';
import { setDataRoom } from 'store/slices/dataRoomSlice';
import classes from './InviteUsersModal.module.scss';
import { setIsInviteUserOpen } from 'store/slices/windowStateSlice';
import ConfigurePermissions from '../ConfigureRoles/components/ConfigurePermissions';
import FooterButtons from './components/FooterButtons';
import CorrectTitle from './components/CorrectTitle';
import RolesSection from './components/RolesSection';
import InvitingUsers from './components/InvitingUsers';
import CreateLinkForm from './components/CreateLinkForm';
import { TFunction } from 'i18next';
import cn from 'classnames';
import { getTheme } from 'helpers/getTheme';
import CollapsedItems from './components/CollapsedItems';

type InviteUsersModalProps = {
  isOpen: boolean;
};

export default function InviteUsersModal ({ isOpen }: InviteUsersModalProps) {
  const [form] = Form.useForm();
  const [linkForm] = Form.useForm();
  const [currentPermissions, setCurrentPermissions] = React.useState<string[]>([]);
  const [currentSection, setCurrentSection] = React.useState<string>('roles'); // roles / users / newRole / links?
  const [isLaoding, setIsLoading] = React.useState(false);
  const [choosenGroup, setChoosenGroup] = React.useState<string>();
  const [invatationsResponce, setInvatationsResponce] = React.useState<NewInvitesResponse>();
  const [newEmails, setNewEmails] = React.useState<string[]>([]);
  const [globalEmails, setGlobalEmails] = React.useState<string[]>([]);
  const [emailIsValid, setEmailIsValid] = React.useState(false);
  const [searchRole, setSearchRole] = React.useState('');
  const [usersInput, setUsersInput] = React.useState('');

  const [arrWithFoldersPermissions, setArrWithFoldersPermissions] = React.useState<any[]>([]);
  const [isLoadingPermissionsByFolders, setIsLoadingPermissionsByFolders]= React.useState(false);
  const [requestingFolderKey, setRequestingFolderKey] = React.useState<string>('');

  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const { groups, selectedGroup, pendingInviteUsers, globalUsers } = useAppSelector((state) => state.dataUsers);
  const { dataRoom } = useAppSelector((state) => state.dataRoom);
  const { userData } = useAppSelector((state) => state.userData);
  const { messageApi } = useAppSelector((state) => state.windowState);

  const groupsOfRoom = groups?.map(({ id, group_name, name }) => ({
    value: id,
    key: group_name,
    label: defaultGroups.includes(name) ? t(`Users.table.${name}`) : name,
  }));

  const usersEmail = [
    ...(dataRoom?.available_users?.map((user) => user.email.toLocaleLowerCase()) || []),
    ...pendingInviteUsers.map(({ email }) => email?.toLocaleLowerCase()),
  ];

  const defaultGroup = groupsOfRoom?.find(group => group.value === selectedGroup?.group_id)
    || groupsOfRoom.find(group => group.key === 'user')
    || groupsOfRoom[0];

  const filteredGroups = React.useMemo(() => groups.filter(({ name }) => defaultGroups.includes(name!)
    ? t(`Users.table.${name}`)?.toLocaleLowerCase().includes(searchRole.toLocaleLowerCase())
    : name?.toLocaleLowerCase().includes(searchRole.toLocaleLowerCase())
  ), [groups, searchRole]);

  const nameOfChoosenGroup = groupsOfRoom?.find(group => group.value === choosenGroup)?.label;

  const onSearchRole = (event: React.ChangeEvent<HTMLInputElement>) => setSearchRole(event.target.value);
  const onSearchUser = (event: React.ChangeEvent<HTMLInputElement>) => setUsersInput(event.target.value);
  
  const emailTest = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i; // /[a-zа-яё0-9]+@[a-zа-яё_-]+\.[a-z]{2,3}/i;
  const isMyEmail = (email: string, userData: IUserData | null): boolean => {
    return userData?.email?.toLowerCase() === email.trim()?.toLowerCase()
  };

  const isUserAlreadyThere = (email: string): boolean => usersEmail?.includes(email.trim());

  const addEmail = () => {
    globalUsers.map(({email}) => email).includes(usersInput)
      ? setGlobalEmails(prev => [...prev, usersInput.trim()])
      : setNewEmails(prev => !prev.includes(usersInput) ? [...prev, usersInput.trim()] : prev);
    setEmailIsValid(false);
    setUsersInput('');
  };
  
  const onChangeCollapse = async (keys: string | string[]) => {
    const currentKey = (keys as string[])?.reverse()[0];
    const indexOfPosition = arrWithFoldersPermissions.findIndex(el => el[0] === currentKey);

    if (indexOfPosition === -1) {
      setRequestingFolderKey(currentKey);
      setIsLoadingPermissionsByFolders(true);
      try {
        if (currentKey) {
          const { data: foldersPermissionsReq } = await api.getFoldersPermissions({room_id: dataRoom?.id!, group_id: currentKey});
          setArrWithFoldersPermissions((prev) => [...prev.filter(folder => folder[0] !== currentKey), [currentKey, ...foldersPermissionsReq]]);
        }
      } catch {} finally {
        setIsLoadingPermissionsByFolders(false);
        setRequestingFolderKey('');
      }
    }
  };

  const itemsCollapse: CollapseProps['items'] = React.useMemo(
    () =>
      filteredGroups?.map(group => {        
        const currentPermissions = groups.find(({ id }) => id === group.id)?.role?.permissions;
        const currentFolderPermissions = arrWithFoldersPermissions.find(el => el[0] === group.id);
        return {
          key: group.id,
          label: <div className={classes.radioWrap}>
            <Radio
              onChange={() => radioCkeck(group.id)}
              checked={choosenGroup === group.id}
              onClick={e => e.stopPropagation()}
            />
            <div>
              {
                defaultGroups.includes(group.name)
                  ? t(`Users.table.${group.name}`)
                  : group.name
              }
            </div>
          </div>,
          children: <CollapsedItems
            group={group}
            currentPermissions={currentPermissions}
            currentFolderPermissions={currentFolderPermissions}
            isLoadingPermissionsByFolders={isLoadingPermissionsByFolders}
            requestingFolderKey={requestingFolderKey}
          />
        }
      }),
    [filteredGroups, arrWithFoldersPermissions, isLoadingPermissionsByFolders, choosenGroup, requestingFolderKey]
  );

  const getError = (t: TFunction, casesObj: {[key: string]: boolean | undefined}): string | undefined => {
    const titles = {
      isUserThere: t('Users.modals.invite.alreadyHere'),
      incorrectEmail: t('Users.modals.invite.incorrectEmail'),
      thisMyEmail: t('Users.modals.invite.yourEmail'),
    }
  
    for (let currentCase in casesObj) {
      if (casesObj[currentCase]) return titles[currentCase as keyof typeof titles]
    };
  };

  const radioCkeck = (groupId: string) => setChoosenGroup(groupId);

  React.useEffect(() => {
    emailTest.test(usersInput) && !isMyEmail(usersInput, userData) && !isUserAlreadyThere(usersInput) && setEmailIsValid(true);
    return () => {
      setEmailIsValid(false);
    }   
  }, [usersInput]);

  React.useEffect(() => {
    const alreadySelectedGroup = localStorage.getItem('alreadySelectedGroup');
    if (alreadySelectedGroup) {
      setChoosenGroup(alreadySelectedGroup);
      setCurrentSection('users');
      localStorage.removeItem('alreadySelectedGroup');
    } else {
      defaultGroup && !invatationsResponce && setChoosenGroup(defaultGroup.value);
    }
    return () => {
      setArrWithFoldersPermissions([]);
      localStorage.removeItem('alreadySelectedGroup');
    }
  }, [groups, invatationsResponce]);
  
  const onCancel = async () => {
    if (invatationsResponce && dataRoom) {
      const usersAction = (await dispatch(fetchGroupsAndUsers({ room_id: dataRoom?.id }))) as any;      
      dispatch(setDataRoom({ ...dataRoom, available_users: usersAction.payload.users }));
    }
    dispatch(setIsInviteUserOpen(false));
  };

  const addEmailAndInvite = async () => {
    if (usersInput.trim() && emailIsValid) {
      addEmail();
    } else {
      setUsersInput('')
    }
    await inviteNewUsers();
  }

  const inviteNewUsers = async () => {
    if (newEmails.length >= 1 || globalEmails.length >= 1) {
      try {
        setIsLoading(true);
        const targetGroup = groups.find(group => group.id === choosenGroup);
        const correctNewEmails = newEmails.map((email) => email.toLocaleLowerCase());
        const allEmails = [...correctNewEmails, ...globalEmails];
        const response = await api.getNewInvite({
          emails: allEmails, room_id: dataRoom?.id!,
          group_id: choosenGroup!,
          type: 'common',
          details: {emails: allEmails, group_name: targetGroup?.name, group_role: targetGroup?.role?.name || '-', group_id: targetGroup?.id,}
        });
        setInvatationsResponce(response.data);
        const successMessage = allEmails.length === 1 ? t('Documents.success.inviteUser') : t('Documents.success.inviteUser');
        messageApi?.success(`${successMessage}: ${allEmails.join(', ')}`, 10);
        dispatch(setIsInviteUserOpen(false));
      } catch (err: any) {
        if (
          err?.response?.data?.message === 'Max members constraint has been violated' ||
          err?.response?.data?.detail?.message === 'Max members constraint has been violated'
        ) {
          messageApi?.error(t('Users.modals.invite.limitError', { maxMembers: dataRoom?.rooms_constraints?.max_members_amount || 10 }));
        } else {
          messageApi?.error(t('Documents.error.inviteUsers'));
        }
      } finally {
        setIsLoading(false);
      }
    } else {
      messageApi?.warning(t('Documents.error.inviteUsersEmpty'))
    }
  };

  const onCreateLink = async (values: { invite_name: string; max_invites?: number; expires_at?: any }) => {
    try {
      setIsLoading(true);
      const ttlInvite = values.expires_at
        ? Math.ceil(dayjs(values.expires_at).diff(dayjs(), 'hour', true))
        : null;

      const response = await api.createInviteLink({
        type: 'common',
        room_id: dataRoom?.id!,
        group_id: choosenGroup!,
        invite_name: values.invite_name,
        invites_amount: values.max_invites ?? null,
        ...(ttlInvite && { ttl_invite: ttlInvite }),
      });

      await navigator.clipboard.writeText(response.data.link);
      messageApi?.success(t('Users.modals.invite.linkForm.linkCopied'));
      linkForm.resetFields();

      if (dataRoom) {
        const usersAction = (await dispatch(fetchGroupsAndUsers({ room_id: dataRoom.id }))) as any;
        dispatch(setDataRoom({ ...dataRoom, available_users: usersAction.payload.users }));
      }
      dispatch(setIsInviteUserOpen(false));
    } catch (err: any) {
      if (
        err?.response?.data?.message === 'Max members constraint has been violated' ||
        err?.response?.data?.detail?.message === 'Max members constraint has been violated'
      ) {
        messageApi?.error(t('Users.modals.invite.limitError', { maxMembers: dataRoom?.rooms_constraints?.max_members_amount || 10 }));
      } else {
        messageApi?.error(t('Users.modals.invite.linkForm.createError'));
      }
    } finally {
      setIsLoading(false);
    }
  };
    
  const displayCorrectSection = {
    roles: <RolesSection
      setCurrentSection={setCurrentSection}
      searchRole={searchRole}
      onSearchRole={onSearchRole}
      itemsCollapse={itemsCollapse}
      onChangeCollapse={onChangeCollapse}
    />,
    users: <InvitingUsers
      emailIsValid={emailIsValid}
      usersInput={usersInput}
      onSearchUser={onSearchUser}
      addEmail={addEmail}
      newEmails={newEmails}
      setNewEmails={setNewEmails}
      globalEmails={globalEmails}
      setGlobalEmails={setGlobalEmails}
      currentError={getError(t, {
        thisMyEmail: isMyEmail(usersInput, userData),
        isUserThere: isUserAlreadyThere(usersInput),
        incorrectEmail: !emailTest.test(usersInput),
      })}
    />,
    newRole: <div className={classes.configureWrap}>
      <ConfigurePermissions
        form={form}
        setCurrentPermissions={setCurrentPermissions}
        currentPermissions={currentPermissions}
        setIsUpdatingRole={setIsLoading}
        isUpdatingRole={isLaoding}
        extraAction={() => setCurrentSection('roles')}
        />
    </div>,
    createLink: (
      <CreateLinkForm form={linkForm} onFinish={onCreateLink} />
    ),
    // links: <CreatedLinks invatationsResponce={invatationsResponce} nameOfChoosenGroup={nameOfChoosenGroup} />,
  }

  return (
    <Modal
      open={isOpen}
      centered
      onCancel={onCancel}
      className={cn(classes.modal, getTheme())}
      title={
        <CorrectTitle
          currentSection={currentSection}
          nameOfChoosenGroup={nameOfChoosenGroup}
        />
      }
      confirmLoading={isLaoding}
      footer={
        <FooterButtons
          currentSection={currentSection}
          setCurrentSection={setCurrentSection}
          onFinish={addEmailAndInvite}
          form={form}
          linkForm={linkForm}
          onCancel={onCancel}
          globalEmails={globalEmails}
          newEmails={newEmails}
          emailIsValid={emailIsValid}
        />
      }
    >
      {displayCorrectSection[currentSection as keyof typeof displayCorrectSection]}

      {(isLaoding || !groups[0]) && <UploadingComponent />}
    </Modal>
  );
};
